import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Table, Tag } from "antd";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { EUserRole, ServiceTemplateField, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { Trans } from "@devowl-wp/react-frontend";
import { useServiceTemplateDynamicFieldTableColumns } from "./dynamic-fields/columns.js";
import { useTranslation } from "../../../../../../others/i18n.js";
import { isExtendedFieldHidden } from "../../../../../../util/template/form.js";
import { QuillSimpleHtmlContent } from "../../../../../third-party/quill-simple-html-content.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
import { DynamicFieldsTable } from "./dynamic-fields/dynamic-fields-table.js";
import { useStores } from "../../../../../../store/root.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
const FormFieldServiceTemplateDynamicFields = observer(()=>{
    const { t } = useTranslation();
    const { rcbAuthenticationStore } = useStores();
    const hasCreatorRole = rcbAuthenticationStore.hasRole(EUserRole.Creator);
    const dynamicFieldsColumns = useServiceTemplateDynamicFieldTableColumns(t);
    const displayColumnDefinition = useMemo(()=>[
            {
                title: t("#"),
                dataIndex: "orderPosition",
                render: (_)=>_ + 1,
                align: "center"
            },
            {
                title: t("Name"),
                dataIndex: "name"
            },
            {
                title: t("Label"),
                dataIndex: "label"
            },
            {
                title: t("Expression"),
                dataIndex: "expression",
                render: (_)=>/*#__PURE__*/ _jsx(Tag, {
                        color: "grey",
                        children: _
                    })
            },
            {
                title: t("Hint"),
                dataIndex: "hint",
                render: (_)=>/*#__PURE__*/ _jsx(QuillSimpleHtmlContent, {
                        value: _,
                        readOnly: true
                    })
            },
            {
                title: t("Invalid Message"),
                dataIndex: "invalidMessage"
            }
        ], []);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ServiceTemplateField.DynamicFields,
        forceHiddenFormCallback: isExtendedFieldHidden(ServiceTemplateField.DynamicFields, hasCreatorRole),
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(ServiceTemplateField.DynamicFields, t),
            extra: /*#__PURE__*/ _jsxs(Trans, {
                children: [
                    "Fields can be used as variables in the following codes. For example, use the variable 'gaMeasurementId' as",
                    /*#__PURE__*/ _jsxs("code", {
                        children: [
                            /*#__PURE__*/ _jsxs("span", {
                                children: [
                                    " ",
                                    "{{"
                                ]
                            }),
                            "gaMeasurementId",
                            /*#__PURE__*/ _jsxs("span", {
                                children: [
                                    "}}",
                                    " "
                                ]
                            })
                        ]
                    }),
                    "within the scripts."
                ]
            }),
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                    extendsFieldName: ServiceTemplateField.DynamicFields,
                    disableStrategies: getDisableStrategies(true),
                    onKeepContent: extended && /*#__PURE__*/ _jsx(Table, {
                        rowKey: "id",
                        pagination: false,
                        dataSource: extended[ServiceTemplateField.DynamicFields],
                        columns: displayColumnDefinition
                    }),
                    children: /*#__PURE__*/ _jsx(DynamicFieldsTable, {
                        formName: ServiceTemplateField.DynamicFields,
                        columns: dynamicFieldsColumns
                    })
                });
            }
        })
    });
});
export { FormFieldServiceTemplateDynamicFields, ServiceTemplateField };
